import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import trial from './trial'
import enrollment from './enrollment'
import location from './location'
import indication from './indication'
import investigator from './investigator'
import coordinator from './coordinator'
import alert from './alert'
import user from './user'
import shared from './shared'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    trial: trial,
    enrollment: enrollment,
    location: location,
    indication: indication,
    investigator: investigator,
    coordinator: coordinator,
    alert: alert,
    user: user,
    shared: shared
  },
  plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/store/index.js